var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.5162 2-1.5118 1.5118 1.1714 1.17143-6.62767 5.31635-1.58488-1.58488-1.5118 1.5118 4.06348 4.0635-6.51493 6.5128v1.4972h1.49718l6.51282-6.5149 4.0635 4.0634 1.5118-1.5117-1.493-1.4931 5.2433-6.70073 1.1526 1.15263 1.5118-1.51178zm1.1672 4.21591 2.1174 2.11735-5.1347 6.56714-3.47671-3.4767z",
    fill: "currentColor"
  })));
}
export default SvgPinreact;